import React from 'react'

import { Badge, Tab, Row, Col, Nav, NavItem } from 'react-bootstrap'

import './spreadsheet-tabs.scss'

// Shamelessly stolen from react-bootstrap
const validChildrenMap = (children, func, context) => {
    let index = 0;
    return React.Children.map(children, child => {
        if (!React.isValidElement(child)) {
            return child;
        }
        return func.call(context, child, index++);
    });
}

class SpreadsheetTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            closeTabs: false
        }
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    componentWillReceiveProps() {
        this.setState({closeTabs: false});
    }
    renderNavItems(child) {
        const { eventKey, title, data } = child.props
        const dataLength = data.length
        const hasData = dataLength > 0
        return (
            <NavItem eventKey={eventKey} disabled={!hasData}>
                {title} {(hasData) && <Badge>{dataLength}</Badge>}
            </NavItem>
        )
    }

    renderTabPane(child) {
        const childProps = { ...child.props }
        delete childProps.title
        delete childProps.data
        return <Tab.Pane {...childProps}>{child}</Tab.Pane>
    }

    getActiveKey(child) {
        const { eventKey, data } = child.props
        if (data.length) {
            return eventKey
        }
        return null
    }

    handleDismiss() {
        this.setState({closeTabs: true});
    }
    render() {
        const { noRender, children } = this.props

        if (noRender || this.state.closeTabs) {
            return null
        }

        const [defaultActiveKey] = validChildrenMap(children, this.getActiveKey).reduce((acc, key) => ((key !== null) ? acc.concat([key]) : acc), [])

        return (
            <Tab.Container id="spreadsheet-tabs" defaultActiveKey={defaultActiveKey}>
                <Row className="clearfix">
                    <Col sm={12}>
                        <span className="closeButton" onClick={this.handleDismiss} onKeyDown={this.handleDismiss} role="button" tabIndex={0}>
                            Close
                        </span>
                        <Nav bsStyle="tabs">
                            {validChildrenMap(children, this.renderNavItems)}
                        </Nav>
                    </Col>
                    <Col sm={12}>
                        <Tab.Content animation>
                            {validChildrenMap(children, this.renderTabPane)}
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        )
    }
}

export default SpreadsheetTabs